import React from 'react';
import Cropper, { CropperProps } from 'react-easy-crop';
import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import { useStyles } from './image-cropper.styles';
import { ImageCropperSlider } from './image-cropper-slider.component';
import clsx from 'clsx';


export type ImageCropperProps = {
  imageUrl: CropperProps['image'];
  onCropComplete: CropperProps['onCropComplete'];
};

export const ImageCropper: React.FC<ImageCropperProps> = (props) => {
  const { classes } = useStyles();
  const [ crop, setCrop ] = React.useState({ x: 0, y: 0 });
  const [ zoom, setZoom ] = React.useState(1);
  const [ tipHidden, setTipHidden ] = React.useState(false);

  return (
    <>
      <Box>
        <div className={clsx({ [classes.cropContainer]: true, 'tip-hidden': tipHidden })}>
          <Cropper
            onInteractionStart={() => setTipHidden(true)}
            image={props.imageUrl}
            crop={crop}
            zoom={zoom}
            aspect={1 / 1}
            showGrid={false}
            zoomWithScroll={false}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={props.onCropComplete}
            style={{
              containerStyle: {
                background: '#fff',
              },
              cropAreaStyle: {
                boxShadow: '0 0 0 9999em rgba(255, 255, 255, 0.6)',
                border: '1px solid rgba(255, 255, 255, 0.8)',
              },
            }}
          />
        </div>
      </Box>
      <Box className={classes.controlWrapper}>
        <Box className={classes.control}>
          <RemoveIcon className={classes.iconLeft} />
          <ImageCropperSlider
            color="secondary"
            value={zoom}
            min={1}
            max={3}
            step={0.05}
            onChange={(e, zoom) => setZoom?.(zoom as number)}
          />
          <AddIcon className={classes.iconRight} />
        </Box>
      </Box>
    </>
  );
};
